import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import WavyDivider from "./WavyDivider";
import { articles, formatDate } from "../data/articles";

const BlogPreview = () => {
  const latest = articles.slice(0, 3);
  return (
    <section id="blog" className="section blog-preview">
      <div className="section-header blog-header">
        <WavyDivider />
        <h2 className="section-title">Le blog</h2>
        <h3 className="section-subtitle">
          Articles, conseils et réflexions autour du Shiatsu, du bien-être et de la santé énergétique.
        </h3>
      </div>

      <div className="blog-grid">
        {latest.map((a) => (
          <Link key={a.slug} to={`/blog/${a.slug}`} className="blog-card">
            <div className="blog-cover">
              <img src={a.cover} alt={a.title} loading="lazy" />
            </div>
            <div className="blog-body">
              <div className="blog-meta">
                <span className="blog-category">{a.category}</span>
                <span className="blog-dot">·</span>
                <time>{formatDate(a.date)}</time>
                <span className="blog-dot">·</span>
                <span>{a.readTime} min</span>
              </div>
              <h4 className="blog-title">{a.title}</h4>
              <p className="blog-excerpt">{a.excerpt}</p>
              <span className="blog-more">
                Lire l’article <ArrowRight size={16} strokeWidth={1.6} />
              </span>
            </div>
          </Link>
        ))}
      </div>

      <div className="blog-cta">
        <Link to="/blog" className="btn btn-primary">VOIR TOUS LES ARTICLES</Link>
      </div>
    </section>
  );
};

export default BlogPreview;
